
import Vue from "vue";

import Headline from "../components/shared/Headline.vue";
import Breadcrumb from "../components/shared/Breadcrumb.vue";
import BreadcrumbItem from "../components/shared/BreadcrumbItem.vue";
import MultiMovies from "../components/shared/MultiMovies.vue";
import {
  ISongWithRank,
} from "../@types/interface.d";

interface DataType {
  ranking: ISongWithRank[] | undefined;
  selected: number;
}

export default Vue.extend({
  name: "ranking",
  components: {
    Headline,
    Breadcrumb,
    BreadcrumbItem,
    MultiMovies,
  },
  data(): DataType {
    return {
      ranking: undefined,
      selected: 1,
    };
  },
  created() {
    this.init();
  },
  beforeRouteUpdate() {
    this.init();
  },
  methods: {
    async init() {
      await fetch("/api/ranking")
        .then(res => res.json())
        .then((data: ISongWithRank[]) => {
          this.ranking = data;
        });
    },
    badgeClick(n: number) {
      this.selected = n;
    },
    isSelected(n: number): string {
      return this.selected === n ? "badge-primary" : "";
    },
    twitterLink(): string {
      return "https://twitter.com/intent/tweet?"
          + `url=${location.href}`
          + "&text=いぎなり東北産の人気曲です\n"
          + "&hashtags=いぎなり東北産";
    },
  },
  computed: {
    showingSongs(): ISongWithRank[] {
      if (!this.ranking) {
        return [];
      }
      const kind = String(this.selected);
      const songs = this.ranking.filter(v => v.scores[kind] > 0).sort((a, b) => {
        const as = a.scores[kind];
        const bs = b.scores[kind];
        return bs - as;
      });
      return songs.slice(0, 20);
    },
    movies(): string[] {
      const song = this.showingSongs[0];
      if (!song || song.movies.length === 0) {
        return [];
      }
      return song.movies;
    },
  },
});

